import FallbackComponent from './FallbackComponent';
export { ErrorType } from './components/ErrorComponent';
export { EmptyType } from './components/EmptyComponent';
export default FallbackComponent;
